import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Pago } from './pagos.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class PagosService {

  private pagosURL: string = urlJoin(environment.apiURL, 'pagos')


  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getPagos(id_expediente: string): Observable<Pago[]> {
    const getPagosURL = urlJoin(this.pagosURL, '/expediente/', id_expediente)
    return this.http.get<Pago[]>(getPagosURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getPago(id: string): Observable<Pago> {
    const getPagosURL = urlJoin(this.pagosURL, id)
    return this.http.get<Pago>(getPagosURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newPago(parte: Pago): Observable<any> {
    return this.http.post<Pago>(this.pagosURL, parte)
      .pipe(
        tap(() => {
          const newPagoSuccessMessage: string = $localize`:@@newPagoSuccessMessage:Nuevo pago creado correctamente`;
          this.notificationsService.showSuccessNotification(newPagoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updatePago(id: string, pago: Pago): Observable<any> {
    const updatePagosURL = urlJoin(this.pagosURL, id)
    return this.http.put<Pago>(updatePagosURL, pago)
      .pipe(
        tap(() => {
          const updatePagoSuccessMessage: string = $localize`:@@updatePagoSuccessMessage:Pago modificado correctamente`;
          this.notificationsService.showSuccessNotification(updatePagoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }


  deletePago(id: string): Observable<any> {
    const deletePagoURL = urlJoin(this.pagosURL, id.toString())
    return this.http.delete<Pago>(deletePagoURL)
      .pipe(
        tap(() => {
          const deletePagoSuccessMessage: string = $localize`:@@updatePagoSuccessMessage:Pago eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deletePagoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
